import * as constants from './constants';
import controller from './controller';

const dispatchFail = (dispatch, failType, error) => {
  return dispatch({ type: failType, payload: { error } });
};

export function resetError() {
  return dispatch => dispatch({
    type: constants.RESET_ERROR,
    payload: { error: null },
  });
}

export function getLastUsers() {
  return dispatch => controller.getLastUsers().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_LAST_USERS_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_LAST_USERS_SUCCESS,
      payload: { lastRegisteredUsers: response.data?.users, error: undefined },
    });
  });
}
